const e = {
  locale: "de-DE",
  country_code: "DE",
  time_zone: "Europe/Berlin",
  // Bump whenever the Terms & Conditions materially change, to prompt
  // re-acceptance from users who accepted an earlier version.
  consent_version: "2026-09-07",
  open_hours: {
    start: 11,
    end: 23
  },
  contact: {
    address: "Schulzendorfer Str. 24, Berlin 13347",
    mobile: "+4915222768409",
    landline_text: "030 55 270 992",
    location: { lat: 52.540944, lng: 13.371778 },
    mobile_text: "+49 15 222 768 409",
    landline: "+493055270992",
    email: "info@castalianspring.de"
  },
  payment: {
    promo: {
      room: {
        type: "room",
        id: "NONE",
        start: /* @__PURE__ */ new Date("2000-01-01T00:00:00Z"),
        end: /* @__PURE__ */ new Date("2100-01-01T00:00:00Z"),
        discount: 0.1,
        discountThreshold: 100
      },
      equip: {
        type: "equip",
        id: "NONE",
        start: /* @__PURE__ */ new Date("2000-01-01T00:00:00Z"),
        end: /* @__PURE__ */ new Date("2100-01-01T00:00:00Z"),
        discountDays: [
          { days: 2, discount: 0.25 },
          { days: 3, discount: 0.3 },
          { days: 4, discount: 0.4 },
          { days: 7, discount: 0.45 }
        ]
      }
    },
    maxAmount: 3e3,
    currency: "EUR",
    vat: [
      { from: -3599267, value: 0.19 },
      { from: 1593554400389, value: 0.16 },
      { from: 1609455600516, value: 0.19 }
    ]
  },
  timeouts: { calendar: 5, payment: 20 }
};
export {
  e as default
};
//# sourceMappingURL=settings.js.map
